import React from "react";
import { AvatarWithInitials } from "@/shared/ui/Avatar";

interface PersonMentionProps {
  name: string;
  avatar?: string;
  initials?: string;
}

const PersonMention: React.FC<PersonMentionProps> = ({
  name,
  avatar,
  initials,
}) => (
  <span className="inline-flex align-bottom mt-2 items-center gap-2 py-[1px] pl-[2px] pr-1 rounded-full text-sm font-medium bg-gray-200 text-gray-700 border border-gray-300 not-prose">
    <AvatarWithInitials
      size="xs"
      avatar={avatar}
      initials={initials || name.charAt(0)}
      className="w-5 h-5"
    />
    <span className="leading-none">{name}</span>
  </span>
);

export default PersonMention;
